import { useInfiniteMessageCentreDepartments } from '@ukpostbox/client-data';
import {
	AlertBanner,
	ButtonSubmit,
	ColourStateSolid,
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FormWrapperLabel,
	Modal,
	SelectItemType,
	UploadFile,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { Controller, FieldValues, FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { CreateThreadModalType } from '../../Types/MessageCentreType';

function CreateThreadModal(props: CreateThreadModalType) {
	const { t } = useTranslation();
	const { data, status } = useInfiniteMessageCentreDepartments();

	const formMethods = useForm({
		defaultValues: {
			subject: '',
			departmentId: props.defaultDepartment || undefined,
			text: props.placeholderMessage || undefined,
			files: undefined,
			containsHtml: false,
		},
		mode: 'onChange',
	});

	const { control, reset, formState } = formMethods;

	const [departmentOptions, setDepartmentOptions] = useState<Array<SelectItemType>>([]);

	const HandleCreate = (formData: FieldValues) => {
		const parsedFormData = new FormData();

		parsedFormData.append('subject', 'subject');
		parsedFormData.append(
			'text',
			props.readOnlyMessage ? `${props.readOnlyMessage}:\n\n ${formData.text}` : formData.text,
		);
		parsedFormData.append('departmentId', formData.departmentId);
		parsedFormData.append('containsHtml', 'false');

		if (formData.files && formData.files.length > 0) {
			formData.files.forEach((file: any) => {
				parsedFormData.append('files', file);
			});
		}

		console.log('parsedFormData', parsedFormData);
		/* startNewMessage(parsedFormData).then((r: any) => {
            if(r.id) {
                navigate(`/message-centre/${r.id}`);

                ipmQueryClient.invalidateQueries([IpmRqKeys.MESSAGE_CENTRE_KEY, 'all']).then(() => null);

                if(props.closeCallback) {
                    props.closeCallback()
                }
            }
        }); */
	};

	const MapDepartmentOptions = () => {
		const newDepartmentOptions = data?.pages.map(
			(page) => page?.data && page.data.map((item) => ({ label: item.name, value: item.id })),
		)[0];

		setDepartmentOptions(newDepartmentOptions || []);
	};

	useEffect(() => {
		if (data) {
			MapDepartmentOptions();
		}
	}, [data]);

	useEffect(() => {
		reset();
	}, [props.isOpen]);

	return (
		<Modal title={t('messageUs.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit((thisData) => HandleCreate(thisData))}>
					<fieldset className='flex-column flex-gap-md'>
						{props.readOnlyMessage && <AlertBanner title={props.readOnlyMessage} />}

						{!props.defaultDepartment && (
							<Controller
								control={control}
								name='departmentId'
								rules={{ required: true }}
								render={({ field, fieldState }) => (
									<FormWrapperLabel
										label={t('messageUs.labels.department')}
										invalid={fieldState.invalid}
										validationMessage={fieldState.error?.message}
									>
										<ComboBoxControl
											name='departmentId'
											data={departmentOptions}
											placeholder={t('messageUs.controls.departmentPlaceholder')}
											loading={status === 'pending'}
											valueType='number'
											displayType={ComboBoxTypeEnum.Single}
											displayItemLabelType={ComboBoxItemDisplayEnum.Label}
											defaultValue={
												props.defaultDepartment ? [props.defaultDepartment] : undefined
											}
											forwardValueCallback={(e: any) => {
												field.onChange(e);
											}}
										/>
									</FormWrapperLabel>
								)}
							/>
						)}

						<Controller
							control={control}
							name='text'
							rules={{ required: true, minLength: { value: 2, message: t('validation.tooShort') } }}
							render={({ field, fieldState }) => (
								<FormWrapperLabel
									label={t('messageUs.labels.message')}
									invalid={fieldState.invalid}
									validationMessage={fieldState.error?.message}
								>
									<textarea
										defaultValue={props.placeholderMessage}
										rows={10}
										aria-invalid={formState.errors.text ? 'true' : 'false'}
										onChange={(e) => field.onChange(e.currentTarget.value)}
									/>
								</FormWrapperLabel>
							)}
						/>

						<Controller
							control={control}
							name='files'
							render={({ field, fieldState }) => (
								<div>
									<FormWrapperLabel
										label={t('messageUs.labels.file')}
										invalid={fieldState.invalid}
										validationMessage={fieldState.error?.message}
									/>
									<UploadFile
										name='New Message Upload File'
										onError={(e) => null}
										onChange={(e) => field.onChange(e)}
										maxFiles={10}
									/>
								</div>
							)}
						/>

						<ButtonSubmit
							title={t('messageUs.actions.send')}
							colour={ColourStateSolid.Primary}
							fullWidth
							disabled={!formState.isValid}
						/>
					</fieldset>
				</form>
			</FormProvider>
		</Modal>
	);
}

export default CreateThreadModal;
